import { clsx } from '@alexis/helpers/clsx';
import React from 'react';

import styles from './RadioButton.module.scss';

type RadioButtonProps = {
  checked?: boolean;
  className?: string;
  id?: string;
  name?: string;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  value?: string | Array<string> | number;
};

const RadioButton: React.FC<RadioButtonProps> = ({
  className,
  id,
  name,
  value,
  checked,
  onChange,
}): JSX.Element => {
  return (
    <div className={clsx(styles.container, className)}>
      <input id={id} type='radio' name={name} value={value} checked={checked} onChange={onChange} />
      <div className={styles.check}></div>
    </div>
  );
};

export default RadioButton;
